import { render, staticRenderFns } from "./audioAndVideoReview.vue?vue&type=template&id=6b0b9c5a&scoped=true&"
import script from "./audioAndVideoReview.vue?vue&type=script&lang=js&"
export * from "./audioAndVideoReview.vue?vue&type=script&lang=js&"
import style0 from "./audioAndVideoReview.vue?vue&type=style&index=0&id=6b0b9c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b9c5a",
  null
  
)

export default component.exports